import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { FaixaConsumoTipoValorEnum } from "core/features/consumo/typings";

const { Option } = Select;

export interface SelectFaixaConsumoTipoValorProps<T = any>
  extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  unidadeMedidaLabel?: string;
}

function SelectFaixaConsumoTipoValor({
  value,
  unidadeMedidaLabel,
  ...rest
}: SelectFaixaConsumoTipoValorProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option
        value={FaixaConsumoTipoValorEnum.UnidadeMedida}
        key={FaixaConsumoTipoValorEnum.UnidadeMedida}
      >
        {unidadeMedidaLabel ?? "Por unidade de medida"}
      </Option>
      <Option
        value={FaixaConsumoTipoValorEnum.ValorFixo}
        key={FaixaConsumoTipoValorEnum.ValorFixo}
      >
        Valor fixo
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectFaixaConsumoTipoValor;
